module.exports = __webpack_public_path__ + "static/media/date-wheel.0ba3da69.png";